export default function (amount, type) {
    let formatter = new Intl.NumberFormat();
    if (type === 'money') {
        amount = amount.toFixed();
    } else if (type === "currency") {
        formatter = new Intl.NumberFormat("en-US", { style: 'currency', currency: 'USD' });
        amount = amount.toFixed(2);
    }
    return formatter.format(amount);
}